import React from "react";

const EmptyState: React.FC<{text: string}> = ({text}) => {
  return (
    <div className="empty-state d-flex flex-column justify-content-center align-items-center w-100">
      <div className="illustration-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="180" viewBox="0 0 200 180" fill="none">
          <g opacity="0.75">
            <path d="M105.236 0.410156L199.987 31.3169C199.987 31.3169 201.793 104.87 162.544 151.829C117.035 136.855 66.4687 120.084 66.4687 120.084C66.4687 120.084 100.781 83.6666 105.236 0.410156Z" fill="#DFE6E5" />
            <rect x="117.262" y="31.3828" width="64.1887" height="3.7413" rx="1.87065" transform="rotate(17.389 117.262 31.3828)" fill="#CAD1D3" />
            <rect x="115.186" y="37.8555" width="36.6535" height="3.7413" rx="1.87065" transform="rotate(17.389 115.186 37.8555)" fill="#CAD1D3" />
            <rect x="168.537" y="38.2422" width="12.9237" height="3.7413" rx="1.87065" transform="rotate(17.389 168.537 38.2422)" fill="#CAD1D3" />
            <rect x="152.723" y="33.4258" width="12.9237" height="3.7413" rx="1.87065" transform="rotate(17.389 152.723 33.4258)" fill="#CAD1D3" />
            <rect x="112.875" y="49.3633" width="36.6535" height="3.7413" rx="1.87065" transform="rotate(17.389 112.875 49.3633)" fill="#CAD1D3" />
            <rect x="109.459" y="60.75" width="36.6535" height="3.7413" rx="1.87065" transform="rotate(17.389 109.459 60.75)" fill="#CAD1D3" />
            <path d="M39.1735 28.582L133.925 59.4887C133.925 59.4887 135.731 133.042 96.4817 180.001C50.9723 165.027 0.406204 148.256 0.406204 148.256C0.406204 148.256 34.7189 111.838 39.1735 28.582Z" fill="#ECF2F1" />
            <rect x="51.5293" y="59.5547" width="64.1887" height="3.7413" rx="1.87065" transform="rotate(17.389 51.5293 59.5547)" fill="#CAD1D3" />
            <rect x="49.4531" y="66.0273" width="36.6535" height="3.7413" rx="1.87065" transform="rotate(17.389 49.4531 66.0273)" fill="#CAD1D3" />
            <rect x="102.805" y="66.4141" width="12.9237" height="3.7413" rx="1.87065" transform="rotate(17.389 102.805 66.4141)" fill="#CAD1D3" />
            <rect x="86.9902" y="61.5977" width="12.9237" height="3.7413" rx="1.87065" transform="rotate(17.389 86.9902 61.5977)" fill="#CAD1D3" />
            <rect x="47.1426" y="77.5352" width="36.6535" height="3.7413" rx="1.87065" transform="rotate(17.389 47.1426 77.5352)" fill="#CAD1D3" />
            <rect x="43.7266" y="88.9219" width="36.6535" height="3.7413" rx="1.87065" transform="rotate(17.389 43.7266 88.9219)" fill="#CAD1D3" />
          </g>
        </svg>
      </div>
      <div className="no-search-results-text">
        {text}
      </div>
    </div>
  );
};

export default EmptyState;
